
riot.tag2('modifications-list-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Модификации товара</div>\n    </yield>\n    <yield to="body">\n      <catalog-static cols="{parent.cols}" rows="{parent.rows}" remove="true" dblclick="{parent.opts.submit.bind(this)}">\n        <yield to="body">\n          <datatable-cell name="name">{row.name}</datatable-cell>\n          <datatable-cell name="stock">{row.stock}</datatable-cell>\n          <datatable-cell name="price">{row.price}</datatable-cell>\n        </yield>\n      </catalog-static>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;
self.rows = [];

self.cols = [{ name: 'name', value: 'Наименование' }, { name: 'stock', value: 'Остаток' }, { name: 'price', value: 'Цена' }];

self.on('update', function () {});

self.on('mount', function () {
    self.loader = true;
    API.request({
        object: 'Product',
        method: 'Info',
        data: { id: [opts.id] },
        notFoundRedirect: false,
        success: function success(response) {
            var name = response.name;
            var modifications = response.modifications;

            self.rows = [];

            if (modifications.length > 0) {
                modifications.forEach(function (item) {
                    var _item = item;
                    var count = item.columns.length;
                    var names = item.columns.map(function (i) {
                        return i.name;
                    });

                    if ('items' in item && item.items instanceof Array && item.items.length > 0) {

                        item.items.forEach(function (item) {
                            item.price = item.priceRetail;
                            if (item.count == -1) item.count = null;
                            var namesValues = item.values.map(function (i) {
                                return i.value;
                            });
                            var row = names.map(function (item, i) {
                                return item + ': ' + namesValues[i];
                            });
                            var value = name + ' (' + row.join(', ') + ')';
                            self.rows.push((0, _extends3.default)({}, item, { name: value }));
                        });
                    }
                });
            }
            self.loader = false;
            self.update();
        }
    });
});
});


// WEBPACK FOOTER //
// ./pages/products/modifications/modifications-list-modal.tag